(function () {
  'use strict';

  /* ─── Money formatting (mirrors Horizon's money-formatting.js) ─── */
  var ZERO_DECIMAL = { BIF:1,CLP:1,DJF:1,GNF:1,ISK:1,JPY:1,KMF:1,KRW:1,MGA:1,PYG:1,RWF:1,UGX:1,VND:1,VUV:1,XAF:1,XOF:1,XPF:1 };

  function formatCents(cents, thou, dec, prec, divisor) {
    var num = (cents / divisor).toFixed(prec);
    var parts = num.split('.');
    var whole = (parts[0] || '0').replace(/\d(?=(\d{3})+(?!\d))/g, function(d){ return d + thou; });
    return prec === 0 ? whole : whole + dec + (parts[1] || '').padEnd(prec, '0');
  }

  function formatMoney(cents, format, currency) {
    currency = (currency || 'USD').toUpperCase();
    format   = format   || '${{amount}}';
    var prec0   = ZERO_DECIMAL[currency] ? 0 : 2;
    var divisor = Math.pow(10, prec0);

    return format.replace(/{{\s*(\w+)\s*}}/g, function(_, key) {
      var thou = ',', dec = '.', prec = prec0;
      switch (key) {
        case 'amount':                                break;
        case 'amount_no_decimals':          prec=0;  break;
        case 'amount_with_comma_separator': thou='.'; dec=','; break;
        case 'amount_no_decimals_with_comma_separator': thou='.'; prec=0; break;
        case 'amount_with_space_separator': thou=' '; dec=','; break;
        case 'amount_no_decimals_with_space_separator': thou=' '; prec=0; break;
        case 'amount_with_period_and_space_separator': thou=' '; break;
        case 'amount_with_apostrophe_separator': thou="'"; break;
        default: return key === 'currency' ? currency : '';
      }
      return formatCents(cents, thou, dec, prec, divisor);
    });
  }

  /* ─── Price DOM update ─── */
  function updateCardPrice(card, variant, moneyFmt, currency) {
    var priceContainer = card.querySelector('[ref="priceContainer"]');
    if (!priceContainer) return;

    var regularDiv = priceContainer.querySelector('.price__regular');
    var saleDiv    = priceContainer.querySelector('.price__sale');
    if (!regularDiv || !saleDiv) return;

    var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (isOnSale) {
      regularDiv.classList.add('price__hidden');
      saleDiv.classList.remove('price__hidden');
      var saleEl    = saleDiv.querySelector('.price-item--sale.price');
      var compareEl = saleDiv.querySelector('.price-item--regular.compare-at-price');
      if (saleEl)    saleEl.textContent    = formatMoney(variant.price,           moneyFmt, currency);
      if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price, moneyFmt, currency);
    } else {
      regularDiv.classList.remove('price__hidden');
      saleDiv.classList.add('price__hidden');
      var regularEl = regularDiv.querySelector('.price');
      if (regularEl) regularEl.textContent = formatMoney(variant.price, moneyFmt, currency);
    }
  }

  /* ─── Picker initialisation ─── */
  function initPicker(wrap) {
    if (wrap._nfReady) return;
    wrap._nfReady = true;

    var dataEl = wrap.querySelector('.nf-vp__data');
    var select = wrap.querySelector('.nf-vp__select');
    if (!dataEl || !select) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    var moneyFmt = wrap.dataset.moneyFormat || '${{amount}}';
    var currency = wrap.dataset.currency    || 'USD';

    // Block all pointer/touch events from reaching the card-link overlay
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function(t) {
      wrap.addEventListener(t, function(e) { e.stopPropagation(); }, { passive: true });
    });
    wrap.addEventListener('click', function(e) { e.stopPropagation(); });

    select.addEventListener('change', function (e) {
      e.stopPropagation();

      var variantId = parseInt(this.value, 10);
      var variant   = variants.find(function(v) { return v.id === variantId; });
      if (!variant) return;

      var card = wrap.closest('product-card');
      if (!card) return;

      // Update ALL variant id inputs in the card (desktop buy-buttons form + mobile compact row form)
      card.querySelectorAll('input[name="id"]').forEach(function(inp) {
        inp.value = variantId;
        inp.dispatchEvent(new Event('change', { bubbles: false }));
      });

      updateCardPrice(card, variant, moneyFmt, currency);

      // Toggle ALL add-to-cart buttons in the card
      card.querySelectorAll('button[name="add"]').forEach(function(btn) {
        btn.disabled = !variant.available;
        if (variant.available) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', 'true');
      });
    });
  }

  /* ─── Bootstrap ─── */
  function initAll() {
    document.querySelectorAll('.nf-vp[data-product-id]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    requestAnimationFrame(function() { requestAnimationFrame(initAll); });
  }

  // Watch for carousel slides added dynamically
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('nf-vp')) {
          initPicker(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.nf-vp[data-product-id]').forEach(initPicker);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
